// src/features/merchantConfig/components/states/LoadingSkeleton.jsx
//
// Skeleton placeholders for both the sidebar (12 rows) and detail panel
// (header ribbon + multiple label/value rows + a nested-object block).
// Skeletons mimic the actual structure rather than being generic rectangles,
// so the layout doesn't jump when real content arrives (UI prompt §8).

import React from "react";

// Use the built-in `animate-pulse` (no Tailwind config extension required).
const shimmer = "animate-pulse bg-gray-200";

export function SidebarSkeleton({ count = 12 }) {
  return (
    <ul className="space-y-1.5" aria-busy="true" aria-label="Loading configuration categories">
      {Array.from({ length: count }).map((_, i) => (
        <li
          key={i}
          className="flex items-center gap-3 rounded-lg border border-gray-100 bg-white px-3 py-2.5"
        >
          <span className={`h-2.5 w-2.5 rounded-full ${shimmer}`} />
          <span className={`h-3.5 flex-1 rounded ${shimmer}`} style={{ maxWidth: "70%" }} />
        </li>
      ))}
    </ul>
  );
}

export function DetailPanelSkeleton() {
  return (
    <div className="space-y-6" aria-busy="true" aria-label="Loading configuration">
      {/* Header ribbon */}
      <div className="space-y-2">
        <div className={`h-6 w-1/3 rounded ${shimmer}`} />
        <div className={`h-4 w-1/2 rounded ${shimmer}`} />
      </div>

      {/* Section 1: top-level scalars */}
      <div className="space-y-3 rounded-lg border border-gray-100 bg-white p-4">
        <div className={`h-3.5 w-24 rounded ${shimmer}`} />
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="space-y-1.5">
              <div className={`h-3 w-1/3 rounded ${shimmer}`} />
              <div className={`h-4 w-2/3 rounded ${shimmer}`} />
            </div>
          ))}
        </div>
      </div>

      {/* Section 2: a nested-object block */}
      <div className="space-y-3 rounded-lg border border-gray-100 bg-white p-4">
        <div className={`h-3.5 w-32 rounded ${shimmer}`} />
        <div className="space-y-2">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className={`h-3 w-1/4 rounded ${shimmer}`} />
              <div className={`h-3 w-1/2 rounded ${shimmer}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
